export const bexio = {
  oAuthFlowHelp: "Authorise my bexio account",
  authSuccess: "The authorisation with bexio was successful."
};
